<template>
  <div class="pill" :class="type" 
   @click="openStockPage" 
  >{{ typeName }}: {{ item.value }} 
  <span class="unit">{{ this.$t('building_page.UNITS') }}</span></div>
</template>

<script>
export default {
  props: ['item', 'pisBuildingId', 'empId'],
  data() {
    return {
      ics: window.ics,
    };
  },
  computed: {
    type() {
      return this.item.type === 'sell' ? 'sell' : 'lease';
    },
    typeName() {
      if (this.item.type === 'sell') {
        return this.$t('stock_info.FOR_SALE');
      } else if (this.item.type === 'lease') {
        return this.$t('stock_info.FOR_LEASE');
      }
      return '';
    },
  },
  methods: {
    openStockPage() {
      let u = `${window.SITE_URL}find/${this.item.type === 'sell' ? 'sale' : 'lease'}?`;
      if (this.pisBuildingId) {
        window.open(`${u}pis_bldg_id=${this.pisBuildingId}`);
      }
      if (this.empId) {
        u = `${u}keywords=${this.item.keyword}`;
        if (this.item.districts) {
          u = `${u}&districts=${this.item.districts}`;
        }
        window.open(u);
      }
    },
  },
};
</script>

<style scoped>
.pill { 
  display: inline-block; 
  padding: 7px 12px; 
  color: #fff;
  font-size: 20px;
  border-radius: 7px;
  cursor: pointer;
}
.sell { background: #FF150D; }
.lease { background: #00BEB5; }
.unit { font-size: 13px }
</style>
